import {useHistory, useParams} from "react-router";
import React, {useEffect} from "react";
import {commitPurchase} from "@/api/purchase";

export const Trade = () => {
  const { id } = useParams()
  const history = useHistory()

  useEffect(() => {
    (async () => {
      await commitPurchase({id})
      history.push(`/card`)
    })()
  }, [history, id])

  return (
    <><div>ご購入を確認中です・・・</div></>
  )
}
